import { CANCEL_REQUEST_MESSAGE } from '../constants/common';

const handleResponse = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  if (response.status === 410) {
    const error = new Error();
    error.text = CANCEL_REQUEST_MESSAGE;

    throw error;
  }
  const error = new Error(response.statusText);
  error.response = response;
  error.text = await response.text();

  throw error;
};

export default handleResponse;
